import { render, staticRenderFns } from "./uploadimage.vue?vue&type=template&id=820d5b8c&scoped=true"
import script from "./uploadimage.vue?vue&type=script&lang=js"
export * from "./uploadimage.vue?vue&type=script&lang=js"
import style0 from "./uploadimage.vue?vue&type=style&index=0&id=820d5b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820d5b8c",
  null
  
)

export default component.exports